module.exports = __webpack_public_path__ + "img/community-apply.3458086d.svg";